import cookies from 'js-cookie';

import { showDraft, showPilApprovedLoan, showPilPreapprovedOffers } from '../config';

// TODO: dotcom заменить на .env или публичный проп
export const officesHref = '/office/';

export const getName = (firstName: string, middleName: string) => {
    if (middleName === '-') return `${firstName}, `;

    return `${firstName} ${middleName}, `;
};

export const safeJSONParse = (jsonString = 'null') => {
    let result: ReturnType<JSON['parse']>;

    try {
        result = JSON.parse(jsonString);
    } catch (e: any) {
        // noop
    }

    return result;
};

// TODO: dotcom заменить на .env или публичный проп
export const getHrefPil = (draftId: string, path = 'draft') =>
    `https://anketa.alfabank.ru/alfaform-refpil/${path}/${draftId}`;

// TODO: dotcom заменить на .env или публичный проп
export const getHrefCC = (draftId: string, product: string) =>
    `https://anketa.alfabank.ru/cc-short/draft?draftId=${draftId}&product=${product}`;

export const getSubdomain = (host: string) =>
    host.includes('localhost') ? 'localhost' : `.${host}`;

/**
 * Удаляет куку по имени.
 * Удаляется умышленно с помощью cookies.set, т.к. cookies.remove не справляется в проде.
 * https://github.com/js-cookie/js-cookie#basic-usage
 * @param cookieName
 */
export const removeCookie = (cookieName: string) =>
    cookies.set(cookieName, '/', {
        domain: getSubdomain(window.location.host),
        expires: 0,
    });

export const getNextViewPil = (hasThanksCookie: boolean, hasPreApprovedOffers: boolean) => {
    if (!hasThanksCookie) return showDraft;

    if (hasPreApprovedOffers) return showPilPreapprovedOffers;

    return showPilApprovedLoan;
};

export const getNextHrefPil = (
    draftId: string,
    hasThanksCookie: boolean,
    hasPreApprovedOffers: boolean
) => {
    if (!hasThanksCookie) return getHrefPil(draftId);

    if (hasPreApprovedOffers && !!draftId) return getHrefPil(draftId, 'offermatrix');

    return officesHref;
};
